import { BCMap, BCMapEntities } from '@bimser/components';
import { IDictionary } from '@bimser/core';
import React from 'react';
import CompositeDataBoundControl from '../../base/CompositeDataBoundControl';
import { ICoordinate } from './entities/ICoordinate';
import { IMapProperties } from './entities/IMapProperties';
import { IMarker } from './entities/IMarker';
import { IRoute } from './entities/IRoute';

export default class Map extends CompositeDataBoundControl {
	apiKey: string;
	center: ICoordinate;
	controls: boolean;
	zoom: number;
	provider: 'bing' | 'google' | 'googleStatic';
	type: 'hybrid' | 'roadmap' | 'satellite';
	routeMode: 'driving' | 'walking';
	routeColor: string;
	routes: IRoute[];
	markers: IMarker[];
	autoAdjust: boolean;
	__mapRef: BCMapEntities.BCMapRef;

	constructor() {
		super();
		this.caption.position = 'top';
		this.center = { lat: 41.0151, lng: 28.9795 };
		this.controls = true;
		this.zoom = 11;
		this.caption.position = 'top';
		this.provider = 'bing';
		this.type = 'roadmap';
		this.routeMode = 'driving';
		this.markers = [];
		this.routes = [];
		this.autoAdjust = true;
		this.style.height = 350;
	}

	override __loadProperties(data: IMapProperties): void {
		super.__loadProperties(data);

		this.__proxyChanged.apiKey = data.apiKey;
		this.__proxyChanged.center = { lat: data.center?.lat || 0, lng: data.center?.lng || 0 };
		this.__proxyChanged.caption.position = data.caption.position;
		this.__proxyChanged.controls = data.controls;
		this.__proxyChanged.zoom = data.zoom;
		this.__proxyChanged.provider = data.provider;
		this.__proxyChanged.type = data.type;
		this.__proxyChanged.routeMode = data.routeMode;
		this.__proxyChanged.routes = data.routes;
		this.__proxyChanged.routeColor = data.routeColor;
		this.__proxyChanged.markers = data.markers;
		this.__proxyChanged.autoAdjust = data.autoAdjust;
	}

	addMarker(_marker: BCMapEntities.IMarker) {
		this.__mapRef.addMarker(_marker);
	}

	removeMarker(_marker: BCMapEntities.IMarker) {
		this.__mapRef.removeMarker(_marker);
	}

	addRoutes(_route: BCMapEntities.IRoute) {
		this.__mapRef.addRoute(_route);
	}

	removeRoutes(_route: BCMapEntities.IRoute) {
		this.__mapRef.removeRoute(_route);
	}

	repaint() {
		this.__mapRef.repaint();
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			center: this.center,
			controls: this.controls,
			zoom: this.zoom,
			provider: this.provider,
			type: this.type,
			routeMode: this.routeMode,
			routes: this.routes,
			routeColor: this.routeColor,
			markers: this.markers,
			autoAdjust: this.autoAdjust,
			apiKey: this.apiKey
		};
	}

	override __render(children: React.ReactNode) {
		return super.__render(
			<BCMap
				ref={ref => (this.__mapRef = ref)}
				center={this.center}
				zoom={this.zoom}
				markers={this.markers}
				apiKey={this.apiKey}
				height={300}
				controls={this.controls}
				width="100%"
				provider={this.provider}
				type={this.type}
				routes={this.routes}
				routeMode={this.routeMode}
				autoAdjust={this.autoAdjust}
				container={this.__form.__getShadowRoot()}
			/>
		);
	}
}
